export enum AnalyticsDomain {
  Visitations = 'VISITATIONS',
}
